module.exports = __webpack_public_path__ + "img/htcm_13.52579c29.jpg";